import { render, staticRenderFns } from "./wtFaceOnCameraCountdown.vue?vue&type=template&id=66c259f2&scoped=true&"
import script from "./wtFaceOnCameraCountdown.vue?vue&type=script&lang=js&"
export * from "./wtFaceOnCameraCountdown.vue?vue&type=script&lang=js&"
import style0 from "./wtFaceOnCameraCountdown.vue?vue&type=style&index=0&id=66c259f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c259f2",
  null
  
)

export default component.exports